/**
* 基础菜单 修改订单商品
*/
<template>
  <div class="contianer">
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="">
        <el-input size="small" v-model="formInline.product_code" placeholder="商品编码" clearable></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="formInline.sale_name" placeholder="商品销售名称" clearable></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="formInline.model" placeholder="商品包装规格" clearable></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="formInline.brand_name" placeholder="商品品牌" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" @click="search">查询</el-button>
        <el-button size="small" type="success" @click="addsortdialog" class="add-button">新增</el-button>
        <el-button size="small" type="info" @click="editupdate" class="edit-button">修改</el-button>
        <el-button size="small" type="danger" @click="delProduct">删除</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <div style="height: 530px;overflow-y: auto">
      <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
                @cell-dblclick="cellDbClick" @selection-change="handleSelectionChange"
                :header-cell-style="{background:'#F5F7FA',color:'#666666'}" :summary-method="getSummaries" show-summary
                element-loading-text="拼命加载中" style="width: 100%;">
        <el-table-column align="center" type="selection" width="60">
        </el-table-column>
        <el-table-column
          label="序号"
          width="60">
          <template slot-scope="scope">
            {{pageparm.pageSize * (pageparm.currentPage - 1) + (scope.$index + 1)}}
          </template>
        </el-table-column>
        <el-table-column prop="product_code" label="商品编码" min-width="200" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="sale_name" label="商品销售名称" width="220" :show-overflow-tooltip='true'>
          <template slot-scope="scope">
            <div style="white-space: pre;" class="over_text_1">{{scope.row.sale_name}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="model" label="商品包装规格" width="220" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="brand_name" label="商品品牌" width="220" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="product_num" label="客户下单数" width="150">
        </el-table-column>
        <el-table-column prop="settle_price" label="销售单价" width="150">
          <template slot-scope="scope">
            <div v-if="scope.row.settle_price||scope.row.settle_price==0">￥{{scope.row.settle_price}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="average_price" label="结算单价" width="150">
          <template slot-scope="scope">
            <div v-if="scope.row.average_price||scope.row.average_price==0">￥{{scope.row.average_price}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="settle_subtotal" label="结算小计" width="150">
          <template slot-scope="scope">
            <div v-if="scope.row.settle_subtotal||scope.row.settle_subtotal==0">￥{{scope.row.settle_subtotal}}</div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false"
               :title="dialogTitle"
               :visible.sync="dialogVisible"
               :before-close="handleClose"
               width="30%"
               center>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="155px" class="ruleForm">
        <el-form-item label="商品销售名称" prop="product_id">
          <el-select v-model="ruleForm.product_id" filterable placeholder="请选择商品销售名称" clearable :disabled="isDisable"
                     remote :filter-method="remoteMethod" class="productInterval" :popper-append-to-body="false"
                     @focus="focusProductName()" @change="changeProductName()" @clear="clear()">
            <el-option :title="item.sale_name"
                       v-for="item in productData"
                       :key="item.product_id"
                       :label="item.sale_name"
                       :value="item.product_id">
            </el-option>
            <div class="pagination-absolute">
              <el-pagination :small="small" style="height: 30px;margin-top: 8px"
                             @size-change="productHandleSizeChange"
                             @current-change="productHandleCurrentChange"
                             :current-page.sync="productCurrentPage"
                             :page-size="productPagesize"
                             layout="total, prev, pager, next"
                             :total="productTotalSize">
              </el-pagination>
            </div>
          </el-select>
        </el-form-item>
        <el-form-item label="销售单价" prop="settle_price" class="r55 relative">
          <el-input v-model="ruleForm.settle_price" clearable placeholder="请输入销售单价" maxlength="8">
          </el-input>
        </el-form-item>
        <el-form-item label="下单数量" prop="product_num" class="r55 relative">
          <el-input v-model="ruleForm.product_num" auto-complete="off" clearable placeholder=" 请输入下单数量" maxlength="8">
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveSort('ruleForm')">{{ falshText }}</el-button>
        <el-button @click="handleClose">取消</el-button>
      </span>
    </el-dialog>

  </div>
</template>
<script>
  import {
    itemList,
    itemAdd,
    itemUpdate,
    itemDetail,
    itemDelete,
    productSaleList,
    itemStockCheck
  } from '../../api/basisMG'
  import Pagination from '../../components/Pagination'
  import {timestampToTime} from "../../utils/util";
  import ElImageViewer from 'element-ui/packages/image/src/image-viewer'

  export default {
    data: () => {
      var settlePrice = (rule, value, callback) => {
        if (value === '' || value == undefined || value == null) {
          return callback(new Error('请输入销售单价'));
        }
        const regex = /^(?:0|[1-9]\d*)(?:\.\d{1,2})?$/;
        if (!regex.test(value)) {
          return callback(new Error('请输入正整数或最多输入两位小数'));
        }
        // 如果通过验证，则正常回调，不传递错误
        return callback();
      };
      var productNum = (rule, value, callback) => {
        if (value === '' || value == undefined || value == null) {
          return callback(new Error('请输入下单数量'));
        } else if (!(/(^[1-9]\d*$)/.test(value))) {
          return callback(new Error('请输入正整数'));
        } else {
          return callback();
        }
      };
      return {
        loading: false,
        dialogVisible: false,  // 弹窗
        dialogTitle: '',  // 标题
        selectTableData: [],
        productId: '',
        falshText: '',
        formInline: {
          page: 1,
          rows: 10,
          order_id: '',
          product_name: '',
          brand_name: '',
          sale_name: '',
          product_code: ''
        },
        ruleForm: {
          id: '',
          order_id: '',
          product_id: '',
          product_num: '',
          settle_price: ''
        },
        rules: {
          product_id: [{required: true, message: '请选择商品销售名称', trigger: 'blur'}],
          settle_price: [{required: true, validator: settlePrice, trigger: 'blur'}],
          product_num: [{required: true, validator: productNum, trigger: 'blur'}],
        },
        listData: [], //用户数据
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        product_id: '',
        productData: [],
        //分页
        productCurrentPage: 1,
        productPagesize: 10,
        productTotalSize: 0,
        saleName: '',
        selectedsaleName: '',
        small: true,
        isDisable:false
      }
    },
    // 注册组件
    components: {
      Pagination, ElImageViewer
    },
    /**
     * 创建完毕
     */
    created() {
      this.getdata(this.formInline);
      this.id = this.$route.query.id;
      if (this.$route.query.id) {
        localStorage.setItem('order_id', this.$route.query.id)
      }
    },
    mounted() {
      if (!this.id) {
        this.id = localStorage.getItem('order_id')
      }
      this.formInline.order_id = this.id;
    },
    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {
      // 获取公司列表
      getdata() {
        this.loading = true
        itemList(this.formInline)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.listData = res.content.rows
              // 分页赋值
              this.pageparm.currentPage = this.formInline.page
              this.pageparm.pageSize = this.formInline.rows
              this.pageparm.total = res.content.total
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      // 分页插件事件
      callFather(parm) {
        this.formInline.page = parm.currentPage
        this.formInline.rows = parm.pageSize
        this.getdata(this.formInline)
      },
      // 搜索事件
      search() {
        this.formInline.page = 1;
        this.getdata(this.formInline)
      },
      handleRemove(file) {
        console.log(file);
      },
      handleSelectionChange(val) {
        this.selectTableData = val
      },
      handleClose() {
        this.$refs["ruleForm"].resetFields();
        this.dialogVisible = false;
      },
      // 新增按扭
      addsortdialog() {
        this.dialogVisible = true;
        this.dialogTitle = '新增订单商品';
        this.falshText = '保存';
        this.isDisable = false;
        this.ruleForm = {
          id: '',
          order_id: '',
          product_id: '',
          product_num: '',
          settle_price: ''
        }
        this.getProduct()
      },
      // 修改按钮
      editupdate() {
        if (this.selectTableData.length == 0) {
          this.$message.error('请选择一条数据再操作!');
          return
        }
        if (this.selectTableData.length > 1) {
          this.$message.error('当前操作只能选择一条数据!');
          return
        }
        this.productId = this.selectTableData[0].item_id;
        this.dialogTitle = '修改订单商品';
        this.falshText = '确认修改';
        this.dialogVisible = true;
        this.isDisable = true;
        this.getProduct(this.selectTableData[0].product_code);
        itemDetail(this.selectTableData[0].item_id)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              if(res.content) {
                this.ruleForm.id = res.content.item_id;
                this.ruleForm.product_id = res.content.product_id;
                this.ruleForm.product_code = res.content.product_code;
                this.ruleForm.product_name = res.content.product_name;
                this.ruleForm.sale_name = res.content.sale_name;
                this.ruleForm.product_num = res.content.product_num;
                this.ruleForm.settle_subtotal = res.content.settle_subtotal;
                this.ruleForm.settle_price = res.content.settle_price
              }
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      // 新增订单商品保存
      saveSort(formName) {
        if (!this.id) {
          this.id = localStorage.getItem('order_id')
        }
        this.ruleForm.order_id = this.id;
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.loading = true;
            if (this.dialogTitle == '新增订单商品') {
              itemAdd(this.ruleForm)
                .then(res => {
                  this.loading = false
                  if (res.success == false) {
                    this.$message({
                      type: 'info',
                      message: res.msg
                    })
                  } else {
                    this.$message({
                      type: 'success',
                      message: '您已成功新增订单商品!'
                    });
                    this.dialogVisible = false;
                    this.getdata(this.formInline)
                  }
                })
                .catch(err => {
                  this.loading = false
                  this.$message.error('网络错误，请稍后再试！')
                })
            } else {
              this.ruleForm.id = this.productId;
              itemUpdate(this.ruleForm)
                .then(res => {
                  this.loading = false
                  if (res.success == false) {
                    this.$message({
                      type: 'info',
                      message: res.msg
                    })
                  } else {
                    this.$message({
                      type: 'success',
                      message: '您已成功修改订单商品!'
                    });
                    this.dialogVisible = false;
                    this.getdata(this.formInline)
                  }
                })
                .catch(err => {
                  this.loading = false
                  this.$message.error('网络错误，请稍后再试！')
                })
            }
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      // 删除
      delProduct() {
        if (this.selectTableData.length == 0) {
          this.$message.error('请选择一条数据再操作!');
          return
        }
        if (this.selectTableData.length > 1) {
          this.$message.error('当前操作只能选择一条数据!');
          return
        }
        const title = '是否确认删除订单商品?';
        this.$confirm(title, '删除订单商品', {
          confirmButtonText: '确认删除',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.loading = true;
          itemDelete(this.selectTableData[0].item_id)
            .then(res => {
              this.loading = false
              if (res.success == false) {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              } else {
                this.$message({
                  type: 'success',
                  message: '删除成功!'
                });
                this.getdata(this.formInline)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('网络错误，请稍后再试！')
            })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
      },
      // 商品销售名称
      getProduct(saleName) {
        let parameter = {
          page: this.productCurrentPage,
          rows: 10,
          keyword: saleName,
          put_away_status: '75',
        };
        productSaleList(parameter)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              if (!res.rows.length) {
                this.selectedsaleName = ''
              }
              this.productData = res.rows;
              this.productTotalSize = res.total;
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      remoteMethod(val) {
        this.productCurrentPage = 1
        this.saleName = val;
        this.getProduct(val)
      },
      // 分页插件事件
      productCallFather() {
        this.getProduct(this.formInline)
      },
      clear() {
        this.getProduct()
        this.productCurrentPage = 1
        this.saleName = ''
      },
      productHandleSizeChange(val) {
        //console.log(`每页 ${val} 条`);
        this.productPagesize = val;
        this.getProduct(this.saleName)
      },
      productHandleCurrentChange(val) {
        //console.log(`当前页: ${val}`);
        this.productCurrentPage = val;
        this.getProduct(this.saleName)
      },
      focusProductName() {
        if (!this.selectedsaleName) {
          this.saleName = ''
          this.getProduct('')
        }
      },
      changeProductName() {
        this.productCurrentPage = 1;
        this.productData.forEach((item) => {
          if (item.product_id == this.ruleForm.product_id) {
            this.selectedsaleName = item.sale_name;
            this.getProduct(item.sale_name)
          }
        })
        const selectedProductId = this.ruleForm.product_id;
        const selectedProduct = this.productData.find(item => item.product_id === selectedProductId);
        if (selectedProduct) {
          this.ruleForm.settle_price = selectedProduct.sale_price;
        } else {
          this.ruleForm.settle_price = '';
        }
      },
      // 合计
      getSummaries(param) {
        const {columns, data} = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '总计';
            return;
          }
          const values = data.map(item => Number(item[column.property]));
          if (column.label == '结算小计') {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            sums[index] = '￥' + sums[index].toFixed(2);
          } else {
            sums[index] = '-';
          }
        });

        return sums;
      },
      //双击复制
      cellDbClick(row, column, cell, event) {
        if (row.product_code == cell.innerText || row.sale_name == cell.innerText || row.model == cell.innerText || row.brand_name == cell.innerText) {
          if (event.type === "dblclick") {
            var save = function (e) {
              e.clipboardData.setData('text/plain', cell.innerText);
              e.preventDefault();//阻止默认行为
            }
            document.addEventListener('copy', save);
            document.execCommand("copy");
            document.removeEventListener('copy', save);
          }
          this.$message({message: '复制成功', type: 'success'})
        }
      }
    }
  }

</script>

<style scoped>
  .contianer {
    background: #fff;
    padding: 20px;
  }

  /deep/ .user-search .el-input__inner {
    height: 40px;
    line-height: 40px;
  }

  /deep/ .user-search .el-form-item {
    margin-bottom: 10px;
  }

  /deep/ .user-search .el-button--small {
    height: 40px;
  }

  /deep/ .el-dialog--center {
    border-radius: 8px !important;
  }

  /deep/ .ruleForm .el-input__inner {
    height: 40px;
    line-height: 40px;
    width: 320px;
  }

  /deep/ .ruleForm .el-select-dropdown__list {
    padding-bottom: 50px;
    min-height: 150px;
  }

  /deep/ .ruleForm .el-select-dropdown__item {
    width: 320px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  /deep/ .ruleForm .el-input--small {
    width: 320px;
  }

  /deep/ .ruleForm .el-select-dropdown__item {
    width: 320px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  /deep/ .ruleForm .el-date-editor.el-input, .el-date-editor.el-input__inner {
    width: 320px;
  }

  /deep/ .el-message-box__title {
    color: #409EFF !important;
  }

  /deep/ .el-dialog__title {
    color: #409EFF !important;
  }

  .breadcrumb {
    margin-bottom: 15px;
  }

  .add-button {
    background: #53B03C;
    border-color: #53B03C;
  }

  .edit-button {
    background: #58B7D6;
    border-color: #58B7D6;
  }

  .pagination-absolute {
    position: absolute;
    bottom: 0;
    background: #fff;
    width: 95%;
    padding-left: 20px;
    height: 40px;
  }

  /deep/ .r55 .el-input__suffix {
    right: 55px !important;
  }

</style>



// WEBPACK FOOTER //
// src/views/order/modifyOrder.vue